export const DESKTOP_DEVICE = '1024px';
